export class InvalidCredentialsError extends Error {
  private static NAME: string = 'InvalidCredentialsError'
  public static MESSAGE: string = 'Credenciais inválidas'

  constructor(message?: string | null) {
    super(message ?? InvalidCredentialsError.MESSAGE)
    this.name = InvalidCredentialsError.NAME
  }
}
